import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { requireAdmin } from '@/lib/auth-guards'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ConfigDrawer } from '@/components/config-drawer'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'

export const Route = createFileRoute('/_authenticated/trainers')({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: TrainersLayout,
})

const trainerTabs = [
  { value: 'trainers', label: 'Entrenadores', to: '/trainers' },
  { value: 'blocked', label: 'Bloqueados', to: '/trainers/blocked' },
  { value: 'students', label: 'Alumnos activos', to: '/trainers/students' },
  { value: 'assign', label: 'Asignar alumno', to: '/trainers/assign' },
  { value: 'new', label: 'Crear entrenador', to: '/trainers/new' },
]

const superAdminTrainerTabs = [
  {
    value: 'attention-report',
    label: 'Atención en sala',
    to: '/trainers/attention-report',
  },
]

function TrainersLayout() {
  const isSuperAdmin = useAuthStore((state) => state.isSuperAdmin())
  const tabs = isSuperAdmin
    ? [...trainerTabs, ...superAdminTrainerTabs]
    : trainerTabs
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })
  const activeTab =
    tabs.find((tab) => pathname === tab.to)?.value ??
    tabs.find((tab) => pathname.startsWith(`${tab.to}/`))?.value ??
    tabs[0].value

  return (
    <>
      <Header fixed>
        <Search />
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <ConfigDrawer />
          <ProfileDropdown />
        </div>
      </Header>

      <Main className='flex flex-1 flex-col gap-4 sm:gap-6'>
        <Tabs value={activeTab} className='space-y-4'>
          <div className='w-full overflow-x-auto pb-2'>
            <TabsList>
              {tabs.map((tab) => (
                <TabsTrigger key={tab.value} value={tab.value} asChild>
                  <Route.Link to={tab.to}>{tab.label}</Route.Link>
                </TabsTrigger>
              ))}
            </TabsList>
          </div>
          <TabsContent value={activeTab} className='space-y-6'>
            <Outlet />
          </TabsContent>
        </Tabs>
      </Main>
    </>
  )
}
